module.exports = __webpack_public_path__ + "media/images/scribe-workbook-b0d7c3d8.png";